import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken';
import { 
    GET_ALL_ORDERS,
    GET_ORDER_REQUEST,
    CHECK_PAYMENT,
    ORDER_LOADING,
    CLEAR_ORDER
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all Orders

export const getOrders = (filters) => async dispatch => {

    try {
        const res = await axios.get(`${API_URL}/orders/all?${filters}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_ORDERS,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched orders', 'success') );
        } else {
            dispatch( setAlert( res.data.error, 'danger' ) );
        }
    } catch ( err ) {
        dispatch( setAlert( 'Failed to feth Orders' ) );
    }

}


// Clear current order
export const clearOrder = () => dispatch => {
    dispatch({
        type: CLEAR_ORDER
    });
};

// Get User Order
export const getOrder = (orderId) => async dispatch => {
    // Set loading state
    dispatch({
        type: ORDER_LOADING
    });

    try {
        const res = await axios.get(`${API_URL}/orders/${orderId}`);
        if(res.data.success){
            dispatch({
                type: GET_ORDER_REQUEST,
                payload: res.data.order
            });
        } else {
            dispatch( setAlert( res.data.error, 'danger' ) );
        }
    } catch ( err ) {
        dispatch( setAlert( 'Failed to fetch Order' ) );
    }
}

// Update order
export const updateOrder = (payload, orderId) => async dispatch => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    try {
        const res =  await axios.put(`${API_URL}/orders/${orderId}`, payload, config);
        if(res.data.success){
            dispatch({
                type: GET_ORDER_REQUEST,
                payload: res.data.order
            });
            dispatch(setAlert('Order Updated', 'success', 700));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
            dispatch({
                type: GET_ORDER_REQUEST,
                payload: res.data.order
            });
        }
    } catch (err) {
        dispatch( setAlert('Error: Failed to update order', 'danger') );
    }
};

// Check Payment
export const verifyPayment = (payload) => async dispatch => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    try {
        const res = await axios.put(`${API_URL}/payment/verify-payment`, payload, config);
        if(res.data.success){
            dispatch({
                type: GET_ORDER_REQUEST,
                payload: res.data.order
            });
            dispatch(setAlert('Payment Updated', 'success'));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
            dispatch({
                type: GET_ORDER_REQUEST,
                payload: res.data.order
            });
        }
    } catch (err) {
        dispatch( setAlert('Error: Failed to update order', 'danger') );
    }
};

const convertOrdersToCSV = (orders) => {
    if (!orders || !Array.isArray(orders) || orders.length === 0) return '';
    const headers = [
        'Order ID',
        'Order Status',
        'User Name',
        'User Phone',
        'Vending Machine',
        'Sector',
        'Date & Time',
        'User Type',
        'MRP',
        'Amount',
        'GST Amount'
    ];

    const escapeCSV = (val) => {
        if (val === null || val === undefined) return '""';
        const str = String(val).replace(/"/g, '""');
        return `"${str}"`;
    };

    const rows = orders.map(order => [
        escapeCSV(order.orderId),
        escapeCSV(order.orderStatus),
        escapeCSV(order.userName),
        escapeCSV(order.userPhone),
        escapeCSV(order.vendingMachine),
        escapeCSV(order.sector),
        escapeCSV(order.date ? new Date(order.date).toLocaleString() : ''),
        escapeCSV(order.userType),
        escapeCSV(order.mrp),
        escapeCSV(order.amount),
        escapeCSV(order.gstAmount)
    ]);

    return [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
};

export const exportOrders = (filters = '') => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        const cleanFilters = filters
            .split('&')
            .filter(param => !param.startsWith('page='))
            .join('&');

        const res = await axios.get(`${API_URL}/orders/all/export?${cleanFilters}`);

        let ordersData = null;
        if (res.data && res.data.success && Array.isArray(res.data.orders)) {
            ordersData = res.data.orders;
        } else if (Array.isArray(res.data)) {
            ordersData = res.data;
        }

        let csvContent = '';
        if (ordersData) {
            csvContent = convertOrdersToCSV(ordersData);
        } else if (typeof res.data === 'string') {
            csvContent = res.data;
        }

        if (!csvContent) {
            dispatch(setAlert('No orders found to export', 'warning', 3000));
            return;
        }

        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `orders-export-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        dispatch(setAlert('Orders exported successfully', 'success', 3000));
    } catch (err) {
        dispatch(setAlert(err.response?.data?.error || 'Failed to export orders', 'danger', 4000));
    }
};